import { render, staticRenderFns } from "./barInfo.vue?vue&type=template&id=25eda3bb&scoped=true"
import script from "./barInfo.vue?vue&type=script&lang=js"
export * from "./barInfo.vue?vue&type=script&lang=js"
import style0 from "./barInfo.vue?vue&type=style&index=0&id=25eda3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eda3bb",
  null
  
)

export default component.exports